"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var bs_1 = require("react-icons/bs");
var mobileDetection_1 = require("../utils/mobileDetection");
var CallView = function (_a) {
    var callState = _a.callState, micStatus = _a.micStatus, onStartEnd = _a.onStartEnd, onMute = _a.onMute, onUnmute = _a.onUnmute;
    var isMobile = (0, mobileDetection_1.useIsMobile)();
    if (isMobile) {
        // Mobile version: Vertical layout
        return (react_1.default.createElement("div", { style: { padding: 20 } },
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 24,
                } },
                react_1.default.createElement("div", { style: {
                        position: "relative",
                        width: 120,
                        height: 120,
                        display: "grid",
                        placeItems: "center",
                    } },
                    react_1.default.createElement("img", { src: callState === "active" && micStatus === "active"
                            ? "assets/Fermaglo_Image03.gif"
                            : "assets/Fermaglo_Image02.png", alt: "", "aria-hidden": "true", style: {
                            position: "absolute",
                            left: "50%",
                            top: "50%",
                            transform: callState === "active" && micStatus === "active"
                                ? "translate(-50%, -50%) scale(1.2)"
                                : "translate(-50%, -50%)",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            pointerEvents: "none",
                            userSelect: "none",
                        } }),
                    react_1.default.createElement("img", { src: "assets/Fermaglo_Image01.png", alt: "Glo brand mark", style: {
                            position: "absolute",
                            left: "50%",
                            top: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 80,
                            height: 80,
                            objectFit: "contain",
                            pointerEvents: "none",
                            userSelect: "none",
                        } })),
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        gap: 16,
                    } },
                    callState === "active" ? (micStatus === "active" ? (react_1.default.createElement("div", { style: { fontSize: 18, fontWeight: 700, color: "#111827" } }, "Assisting Now")) : (react_1.default.createElement("div", { style: { fontSize: 18, fontWeight: 700, color: "#111827" } }, "Muted"))) : (react_1.default.createElement("div", { style: { fontSize: 18, fontWeight: 700, color: "#111827" } },
                        "Glo is ",
                        react_1.default.createElement("span", { style: { color: "#22C55E" } }, "Available"))),
                    callState === "active" ? (micStatus === "active" ? (react_1.default.createElement("button", { onClick: function (e) {
                            e.stopPropagation();
                            onMute();
                        }, style: {
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "12px 24px",
                            borderRadius: 999,
                            border: "1px solid #E5E7EB",
                            background: "#EDE7F6",
                            color: "#4B5563",
                            fontWeight: 600,
                            fontSize: 15,
                            cursor: "pointer",
                            minWidth: 120,
                        } }, "Mute")) : (react_1.default.createElement("button", { onClick: function (e) {
                            e.stopPropagation();
                            onUnmute();
                        }, style: {
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "12px 24px",
                            borderRadius: 999,
                            border: "1px solid #D1D5DB",
                            background: "#6B21A8",
                            color: "#fff",
                            fontWeight: 600,
                            fontSize: 15,
                            cursor: "pointer",
                            minWidth: 120,
                        } }, "Unmute"))) : (react_1.default.createElement("button", { onClick: function (e) {
                            e.stopPropagation();
                            onStartEnd();
                        }, style: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 10,
                            padding: "12px 24px",
                            borderRadius: 999,
                            border: "1px solid #D1D5DB",
                            background: "#ffffff",
                            color: "#6B21A8",
                            fontWeight: 600,
                            fontSize: 15,
                            cursor: "pointer",
                        } },
                        react_1.default.createElement("span", { style: {
                                display: "inline-flex",
                                width: 30,
                                height: 30,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "50%",
                                background: "#F3E8FF",
                            } },
                            react_1.default.createElement(bs_1.BsFillTelephoneFill, null)),
                        "Start a Call"))))));
    }
    // Desktop version: Original horizontal layout
    return (react_1.default.createElement("div", { style: { padding: 20 } },
        react_1.default.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 24,
            } },
            react_1.default.createElement("div", { style: {
                    position: "relative",
                    width: 140,
                    height: 140,
                    display: "grid",
                    placeItems: "center",
                } },
                react_1.default.createElement("img", { src: callState === "active" && micStatus === "active"
                        ? "assets/Fermaglo_Image03.gif"
                        : "assets/Fermaglo_Image02.png", alt: "", "aria-hidden": "true", style: {
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: callState === "active" && micStatus === "active"
                            ? "translate(-50%, -50%) scale(1.35)"
                            : "translate(-50%, -50%)",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        pointerEvents: "none",
                        userSelect: "none",
                    } }),
                react_1.default.createElement("img", { src: "assets/Fermaglo_Image01.png", alt: "Glo brand mark", style: {
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 92,
                        height: 92,
                        objectFit: "contain",
                        pointerEvents: "none",
                        userSelect: "none",
                    } })),
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    textAlign: "left",
                    gap: 16,
                } },
                callState === "active" ? (micStatus === "active" ? (react_1.default.createElement("div", { style: { fontSize: 20, fontWeight: 700, color: "#111827" } }, "Assisting Now")) : (react_1.default.createElement("div", { style: { fontSize: 20, fontWeight: 700, color: "#111827" } }, "Muted"))) : (react_1.default.createElement("div", { style: { fontSize: 20, fontWeight: 700, color: "#111827" } },
                    "Glo is ",
                    react_1.default.createElement("span", { style: { color: "#22C55E" } }, "Available"))),
                callState === "active" ? (micStatus === "active" ? (react_1.default.createElement("button", { onClick: function (e) {
                        e.stopPropagation();
                        onMute();
                    }, style: {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "12px 18px",
                        borderRadius: 999,
                        border: "1px solid #E5E7EB",
                        background: "#EDE7F6",
                        color: "#4B5563",
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                        minWidth: 140,
                    } }, "Mute")) : (react_1.default.createElement("button", { onClick: function (e) {
                        e.stopPropagation();
                        onUnmute();
                    }, style: {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "12px 18px",
                        borderRadius: 999,
                        border: "1px solid #D1D5DB",
                        background: "#6B21A8",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                        minWidth: 140,
                    } }, "Unmute"))) : (react_1.default.createElement("button", { onClick: function (e) {
                        e.stopPropagation();
                        onStartEnd();
                    }, style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "12px 18px",
                        borderRadius: 999,
                        border: "1px solid #D1D5DB",
                        background: "#ffffff",
                        color: "#6B21A8",
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                    } },
                    react_1.default.createElement("span", { style: {
                            display: "inline-flex",
                            width: 30,
                            height: 30,
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            background: "#F3E8FF",
                        } },
                        react_1.default.createElement(bs_1.BsFillTelephoneFill, null)),
                    "Start a Call"))))));
};
exports.default = CallView;
